"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.borderBottom = exports.borderRight = exports.confusionMatrixSquareGreen = exports.confusionMatrixSquareRed = exports.confusionMatrixPercent = exports.confusionMatrixPercentageCell = exports.confusionMatrixCellShort = exports.confusionMatrixCell = exports.subHeader = exports.confusionMatrixCellSkinny = exports.confusionMatrixTable = exports.legendLabel = exports.legendValidation = exports.legendNoModel = exports.legend = exports.lineChartTitle = exports.lineChartContainer = exports.barLabel = exports.axis = exports.axisLabel = exports.VarCorrelationTableChart = exports.VarCorrelationTableCell = exports.VarCorrelationTableRow = exports.VarCorrelationTableHeader = exports.VarCorrelationTableWithChart = exports.VarCorrelationTable = exports.VarCorrelationTableContainer = exports.alertsIcon = exports.alertsNumDataAlertsText = exports.alertsQualityCheckMessage = exports.alertsHeader = exports.alertsSection = exports.progressBarLabels = exports.progressBarHeaderLeft = exports.progressBarHeaderText = exports.progressBarHeader = exports.cardButton = exports.cardDescription = exports.cardTitle = exports.cardBorderShadow = exports.cardBorder = exports.card = exports.cardContainerWide = exports.cardContainer = exports.varCorrelationTableCellHeight = exports.chartAxisSize = exports.chartFontSize = void 0;
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
var typestyle_1 = require("typestyle");
var colors = require("../util/colors");
var sizes = require("../util/sizes");
require("@tableau/fonts-tableau");
// SIZE CONSTANTS
exports.chartFontSize = '9px';
exports.chartAxisSize = '1px';
exports.varCorrelationTableCellHeight = '16px';
// CARD
exports.cardContainer = typestyle_1.style({
    width: sizes.cardWidthRegular.toString() + 'px',
    margin: '0.5em',
    height: '100%',
});
exports.cardContainerWide = typestyle_1.style({
    width: sizes.cardWidthWide.toString() + 'px',
    margin: '0.5em',
    height: '100%',
});
exports.card = typestyle_1.style({
    padding: '1.5em',
    display: 'flex',
    flexDirection: 'column',
});
exports.cardBorder = typestyle_1.style({
    border: 'solid #b3b3b3 thin',
});
exports.cardBorderShadow = typestyle_1.style({
//border: 'solid #b3b3b3 thin',
//boxShadow: 'rgb(0 0 0 / 15%) 1.95px 1.95px 2.6px', // TODO: style box shadow closer to UX
});
exports.cardTitle = typestyle_1.style({
    marginBottom: '0.5em',
    fontWeight: 'bold',
});
exports.cardDescription = typestyle_1.style({
    fontSize: '12px',
    marginBottom: '1.25em',
    color: colors.gray,
});
exports.cardButton = typestyle_1.style({
    color: '#46a0dc',
    border: 'solid #b3b3b3 thin',
    width: '100%',
    height: '3em',
    cursor: 'pointer',
});
// PROGRESS BAR
exports.progressBarHeader = typestyle_1.style({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: '0.25em',
    marginBottom: '0.5em',
});
exports.progressBarHeaderText = typestyle_1.style({
    fontWeight: 'bold',
    marginRight: '0.25em',
    fontSize: '14px',
});
exports.progressBarHeaderLeft = typestyle_1.style({
    display: 'flex',
});
exports.progressBarLabels = typestyle_1.style({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: '0.5em',
    color: colors.lightGray,
    fontSize: '10px',
});
// ALERTS
exports.alertsSection = typestyle_1.style({
    display: 'flex',
    flexDirection: 'column',
});
exports.alertsHeader = typestyle_1.style({
    fontWeight: 'bold',
    fontSize: '12px',
    marginBottom: '0.5em',
});
exports.alertsQualityCheckMessage = typestyle_1.style({
    fontSize: '10px',
    color: colors.gray,
    display: 'flex',
    alignItems: 'center',
    marginBottom: '1em',
});
exports.alertsNumDataAlertsText = typestyle_1.style({
    fontSize: '10px',
    display: 'flex',
    alignItems: 'center',
});
exports.alertsIcon = typestyle_1.style({
    marginRight: '0.5em',
});
// VARIABLE CORRELATION TABLE
exports.VarCorrelationTableContainer = typestyle_1.style({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'start',
    // maxHeight: '10em', TODO: Make this scrollable?
    // overflowY: 'auto',
});
exports.VarCorrelationTable = typestyle_1.style({
    width: '100%',
    marginRight: '0.5em',
});
exports.VarCorrelationTableWithChart = typestyle_1.style({
    width: '40%',
    borderSpacing: '0px',
    borderCollapse: 'collapse',
});
exports.VarCorrelationTableHeader = typestyle_1.style({
    fontSize: exports.chartFontSize,
    fontFamily: 'Tableau',
    fontWeight: 'bold',
    textAlign: 'left',
});
exports.VarCorrelationTableRow = typestyle_1.style({
    color: colors.gray,
    fontSize: exports.chartFontSize,
});
exports.VarCorrelationTableCell = typestyle_1.style({
    height: exports.varCorrelationTableCellHeight,
    border: 'solid 1px transparent',
});
exports.VarCorrelationTableChart = typestyle_1.style({
    marginTop: '14px',
});
// D3 CHARTS
// Dimension headers
exports.axisLabel = typestyle_1.style({
    fontSize: exports.chartFontSize,
    fontFamily: 'Tableau',
    fontWeight: 'bold',
    textAnchor: 'middle',
    color: colors.gray,
});
exports.axis = typestyle_1.style({
    color: colors.gray,
    fontFamily: 'Tableau',
    fontWeight: 'lighter',
    fontSize: exports.chartFontSize,
    strokeWidth: 0,
});
exports.barLabel = typestyle_1.style({
    fontSize: '10px',
});
// LINE CHART
exports.lineChartContainer = typestyle_1.style({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '0.5em',
});
exports.lineChartTitle = typestyle_1.style({
    marginBottom: '0.5em',
    // fontWeight: 'bold',
    fontFamily: 'Tableau',
});
exports.legend = typestyle_1.style({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
});
exports.legendNoModel = typestyle_1.style({
    width: '0.75em',
    height: '0.75em',
    backgroundColor: colors.black,
    opacity: 0.29,
});
exports.legendValidation = typestyle_1.style({
    width: '0.75em',
    height: '0.75em',
    backgroundColor: colors.defaultBlue,
    marginLeft: '1em;',
});
exports.legendLabel = typestyle_1.style({
    fontSize: exports.chartFontSize,
    fontFamily: 'Tableau',
    marginLeft: '0.5em',
    marginRight: '0.5em',
});
exports.confusionMatrixTable = typestyle_1.style({
    borderSpacing: '0px',
    borderCollapse: 'collapse',
    fontFamily: 'Tableau',
    textAlign: 'center',
    fontSize: '12px', // Check with UX Later
});
exports.confusionMatrixCellSkinny = typestyle_1.style({
    width: '5.0em',
    padding: '0.25em 0.25em 0.25em 0.25em',
});
exports.subHeader = typestyle_1.style({
    fontWeight: 'normal',
});
exports.confusionMatrixCell = typestyle_1.style({
    width: '5.5em',
    padding: '0.25em 0.5em 0.25em 0.5em',
});
exports.confusionMatrixCellShort = typestyle_1.style({
    width: '5.5em',
    padding: '0.25em 0.5em 0.25em 0.5em',
});
exports.confusionMatrixPercentageCell = typestyle_1.style({
    display: 'flex',
    flexDirection: 'column',
    fontSize: exports.chartFontSize,
    color: colors.gray,
});
exports.confusionMatrixPercent = typestyle_1.style({
    fontSize: '12px',
    color: 'black',
});
exports.confusionMatrixSquareRed = typestyle_1.style({
    backgroundColor: colors.lightRed,
    color: colors.red,
});
exports.confusionMatrixSquareGreen = typestyle_1.style({
    backgroundColor: colors.lightGreen,
    color: colors.green,
});
exports.borderRight = typestyle_1.style({
    borderRight: '1px solid ' + colors.lightGray,
});
exports.borderBottom = typestyle_1.style({
    borderBottom: '1px solid ' + colors.lightGray,
});
//# sourceMappingURL=PredictionModelResultsViz.js.map